@if (warningTransformationLogItem?.warningCode === 'FRE_REDUZIERUNG_NON_PRESENT') {
  <span>
    In der Spalte <i>{{formatArray(warningTransformationLogItem.columnNames)}}</i> wurde kein Wert angegeben. Es wird daher angenommen, dass keine Leistungsreduzierung vorliegt.
  </span>
}

@if (warningTransformationLogItem?.warningCode === 'ANLAGENTYP_DOESNT_MATCH_INSTALLIERTE_LEISTUNG') {
  <span>
    Die installierte Leistung und der Anlagentyp Primärenergieträger passen nicht zueinander. PVk-Anlagen dürfen <i>maximal</i> 99 kW besitzen und PV-Anlagen <i>minimal</i> 100 kW.
  </span>
}

@if (warningTransformationLogItem?.warningCode === 'ANLAGENTYP_DOESNT_MATCH_ENERGIEART_FRE') {
  <span>
    Die Energieart des FRE und der Anlagentyp Primärenergieträger passen nicht zueinander. Bitte passen Sie einen der Werte an.
  </span>
}
